export enum AppConstants {
  LEAK = "leak",
  CRACK = "crack",
  CORROSION = "corrosion",
  Anomaly = "anomaly",
  Pest = "pest",
  Disease="disease",
  Growth="growth",
  dicSensor="dicSensor",
  smartCombi="smartCombi",
  RED = "#e4202c",
  SKYBLUE = "#2baae1",
  GREEN = "#69bd44",
  STOCK = "stock",
  CUSTOMERANALYSIS = "customeranalysis"
}
